import React, { useState } from 'react';
import cx from 'classnames';

import Card from '@marketing/components/card';
import SectionHeader from '@marketing/components/section_header';

import AIEssayDetailedGradingFeature from './assets/ai_essay_detailed_grading_feature.png';
import AIEssaySuggestedEditsFeature from './assets/ai_essay_suggested_edits_feature.png';
import AIPracticeQuestionsFeature from './assets/ai_practice_questions_feature.png';
import AITutorFeature from './assets/ai_tutor_feature.png';
import SparkleBg from './assets/sparkle_bg.svg';
import SparkleIcon from './assets/sparkle_icon.svg';
import marketingStyles from '@marketing/style.module.scss';
import styles from './style.module.scss';

export default (props) => {
  const [selectedAIEssayGraderValueProp, setSelectedAIEssayGraderValueProp] = useState('suggestedEdits');

  return (
    <div className="d-flex flex-column gap-l u-margin-T-xl" style={{ position: 'relative' }}>
      <SparkleBackground />

      <SectionHeader
        reveal
        subtitle="Get instant, GRE-style essay scoring and targeted feedback, chat with an expert AI tutor, and practice with Magoosh."
        supertitle="AI test prep"
        supertitleIcon={SparkleIcon}
        title="Study smarter with AI"
      />

      <div className={cx(styles.aiFeaturesContainer, 'd-flex flex-column gap-m gap-lg-l')}>
        <div className="d-flex flex-column flex-lg-row gap-m gap-lg-l">
          <Card className="d-flex flex-1 flex-column gap-m">
            <div>
              <img
                alt="Examples of helpful conversations with the AI tutor"
                loading="lazy"
                src={AITutorFeature}
              />
            </div>

            <div className="d-flex flex-column gap-s">
              <div className="text-bold text-inter">
                AI Tutor
              </div>

              <div className="text-inter" style={{ fontSize: 15 }}>
                Chat with an AI expert trained on lessons and content and ready to explain whatever you don’t grasp.
              </div>
            </div>
          </Card>

          <Card className="d-flex flex-1 flex-column gap-m">
            <div>
              <img
                alt="Examples of AI-generated similar practice questions"
                loading="lazy"
                src={AIPracticeQuestionsFeature}
              />
            </div>

            <div className="d-flex flex-column gap-s">
              <div className="text-bold text-inter">
                5,000+ AI-Crafted Practice Questions
              </div>

              <div className="text-inter" style={{ fontSize: 15 }}>
                Missed a question? Get similar, high-quality AI-generated problems to practice again.
              </div>
            </div>
          </Card>
        </div>

        <Card className="d-flex flex-1 flex-column flex-lg-row-reverse gap-m">
          <div>
            <img
              alt="Examples of AI detailed essay grading"
              loading="lazy"
              src={AIEssayDetailedGradingFeature}
              style={{ display: selectedAIEssayGraderValueProp === 'detailedGrading' ? 'block' : 'none' }}
            />
            <img
              alt="Examples of AI suggested edits to your essay"
              loading="lazy"
              src={AIEssaySuggestedEditsFeature}
              style={{ display: selectedAIEssayGraderValueProp === 'suggestedEdits' ? 'block' : 'none' }}
            />
          </div>

          <div className="d-flex flex-column gap-s">
            <div className="text-bold text-inter">
              AI Essay Grader
            </div>

            <div className="text-inter" style={{ fontSize: 15 }}>
              Our AI grades your essay like a real GRE rater, then provides feedback to boost your score.
            </div>

            <div className="d-flex flex-column u-margin-T-s u-padding-L-xs">
              <div
                className="text-inter text-medium u-padding-L-s u-padding-V-xxs"
                onClick={() => setSelectedAIEssayGraderValueProp('detailedGrading')}
                style={{
                  borderColor: selectedAIEssayGraderValueProp === 'detailedGrading' ? '#000000' : '#EDEDED',
                  borderStyle: 'solid',
                  borderWidth: '0 0 0 1px',
                  color: selectedAIEssayGraderValueProp === 'detailedGrading' ? '#5C5C5C' : '#ADADAD',
                  cursor: selectedAIEssayGraderValueProp === 'detailedGrading' ? 'initial' : 'pointer'
                }}
              >
                Detailed Grading
              </div>

              <div
                className="text-inter text-medium u-padding-L-s u-padding-V-xxs"
                onClick={() => setSelectedAIEssayGraderValueProp('suggestedEdits')}
                style={{
                  borderColor: selectedAIEssayGraderValueProp === 'suggestedEdits' ? '#000000' : '#EDEDED',
                  borderStyle: 'solid',
                  borderWidth: '0 0 0 1px',
                  color: selectedAIEssayGraderValueProp === 'suggestedEdits' ? '#5C5C5C' : '#ADADAD',
                  cursor: selectedAIEssayGraderValueProp === 'suggestedEdits' ? 'initial' : 'pointer'
                }}
              >
                Suggested Edits
              </div>
            </div>
          </div>
        </Card>
      </div>

      <div className="u-margin-T-xl">
        <SparkleBackground mirror />
      </div>
    </div>
  );
};

const SparkleBackground = ({ mirror = false }) => {
  return (
    <>
      <div
        className={marketingStyles.fullPageWidthContainerBreakout}
        style={{
          background: 'linear-gradient(to bottom, transparent, #F2E9FB 30%, #FCECF7 70%, transparent)',
          bottom: mirror ? -75 : 'initial',
          height: 300,
          position: 'absolute',
          top: mirror ? 'initial' : -75,
          zIndex: -3
        }}
      />
      <div
        style={{
          bottom: mirror ? -75 : 'initial',
          height: 300,
          position: 'absolute',
          top: mirror ? 'initial' : -75,
          transform: mirror ? 'scaleX(-1) scaleY(-1)' : '',
          width: '100%',
          zIndex: -2
        }}
      >
        <img alt="" src={SparkleBg} />
      </div>
      <div
        className={marketingStyles.fullPageWidthContainerBreakout}
        style={{
          background: 'linear-gradient(to bottom, #fff, transparent 50%, #fff)',
          bottom: mirror ? -75 : 'initial',
          height: 310,
          position: 'absolute',
          top: mirror ? 'initial' : -75,
          zIndex: -1
        }}
      />
    </>
  );
};
